export default class TypeFailure {
	id: number;					//ид
	category: string;			//категория
	specification: string;		//описание
}